import React, { useEffect } from 'react'
import {
  BlankSlate,
  Description,
  PrimaryActionButton,
  SecondaryActionButton,
  SubTitle
} from '@cjdev/visual-stack/lib/components/BlankSlate'
import '@cjdev/visual-stack/lib/css/base.css'
import '@cjdev/visual-stack/lib/css/bootstrap-cj.css'
import '@cjdev/visual-stack/lib/css/forms.css'
import '@cjdev/visual-stack/lib/css/layout.css'
import '@cjdev/visual-stack/lib/css/globalVariables.css'

import './ErrorMessage.css'
import { getErrorPageContents } from './error-page-contents'

export const ErrorMessage = (props) => {
  useEffect(() => {
    document.title = 'Error - CJ Affiliate'
  })
  const params = new URLSearchParams(window.location.search)

  // all possible parameters Auth0 might send us: https://auth0.com/docs/universal-login/custom-error-pages
  const errorCode = params.get('error')
  const errorDescription = params.get('error_description')

  const { title, subtitle1, subtitle2, imgSrc } = getErrorPageContents(errorCode, errorDescription)

  return (
    <BlankSlate
      title={title}
      headerGraphic={
        <img
          src={imgSrc}
          alt={'error graphic'}
          className={'headerGraphic'}
        />
      }
    >
      <SubTitle>
        <p>{subtitle1}</p>
      </SubTitle>

      <Description>
        <p>{subtitle2}</p>
      </Description>

      {errorCode === '503' ? (
        <PrimaryActionButton label={'REFRESH PAGE'} handler={() => props.history.back()} />
      ) : (
        <PrimaryActionButton
          label={'GO TO THE HOMEPAGE'}
          className={'primaryButton'}
          handler={() => props.history.push('https://www.cj.com')}
        />
      )}

      {errorDescription !== 'unverified_email' && <SecondaryActionButton
        label={'SUPPORT LINK'}
        handler={() => props.history.push('https://www.cj.com/support')}
      />}
    </BlankSlate>
  )
}
